import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { ProfessionalApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application, Cohorts } from '@platform/client';
import { CohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';

export const EYConfirmAndSubmit = (props: ApplicationPageProps) => {
	const [failed, setFailed] = useState(false);
	const { getApplicationData } = useApplicationLocalStorage<ProfessionalApplicationParameters>(
		props.dataKey,
	);
	const submitEYMutation = Application.useSubmitEyApplication();
	const queryClient = useQueryClient();
	const { data: cohortData, isSuccess } = Cohorts.useGetCurrentUserCurrentCohort();

	const submit = () => {
		submitEYMutation.mutate(
			{
				data: {
					...getApplicationData(),
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
					});
				},
				onError: () => {
					setFailed(true);
				},
			},
		);
	};

	return (
		<>
			{isSuccess && cohortData && <CohortDetails {...props} cohortData={cohortData} onBack={props.onBack} onSubmit={submit} />}
			{failed && (
				<ErrorBox showAlertTriangle={true}>
					There was an error submitting your application. Please try again later.
				</ErrorBox>
			)}
		</>
	);
};
